import { createClient } from '@supabase/supabase-js';

function readConfig() {
  const url = process.env.REACT_APP_SUPABASE_URL || process.env.SUPABASE_URL || '';
  const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.SUPABASE_ANON_KEY || '';
  if (!url || !anonKey) return null;
  return { url, anonKey };
}

export function createSupabaseAuthClient() {
  const config = readConfig();
  if (!config) return null;
  return createClient(config.url, config.anonKey, {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
    },
  });
}

function notConfigured() {
  return {
    data: { user: null, session: null },
    error: { message: 'Supabase Auth is not configured', status: 503 },
  };
}

export async function signInWithPassword(email, password) {
  const client = createSupabaseAuthClient();
  if (!client) return notConfigured();
  return client.auth.signInWithPassword({ email, password });
}

export async function signUp(email, password, metadata) {
  const client = createSupabaseAuthClient();
  if (!client) return notConfigured();
  return client.auth.signUp({
    email,
    password,
    options: { data: metadata || {} },
  });
}

export async function signOut() {
  const client = createSupabaseAuthClient();
  if (!client) return;
  await client.auth.signOut();
}
